import MarketingCampaignDetail from '@/Component/Admin/MarketingCampaign/MarketingCampaignDetail'

const MarketingCampaignDetailPage = async ({ params }: { params: Promise<{ id: string }>; }) => {
    const resolvedParams = await params;
    const id = Array.isArray(resolvedParams.id)
        ? resolvedParams.id[0]
        : resolvedParams.id;
    return <MarketingCampaignDetail id={id} />;
};

export default MarketingCampaignDetailPage;
